// Role constants matching backend role codes

export const RoleConstants = {
  Administrator: 'ADMINISTRATOR',
  Therapist: 'THERAPIST',
  Receptionist: 'RECEPTIONIST',
  Client: 'CLIENT'
} as const;
